// Single source of truth for the displayed app version (keep in sync with package.json).
export const APP_VERSION = "3.0.0";
